export default "__VITE_ASSET__7d0a467c__"